/**
 * Hlásenie chýb, ktoré poistka okolo stránok nezachytí.
 *
 * `ErrorBoundary` vie zachytiť len pád pri **vykresľovaní**. Chyba v obsluhe
 * kliknutia, v načítaní údajov alebo v nesplnenom prísľube prejde mimo neho –
 * v prehliadači sa vypíše do konzoly a nikto sa o nej nedozvie. Práve tie sú
 * pritom najnepríjemnejšie: tlačidlo „nič nerobí" a nie je čo hľadať.
 *
 * Preto sa počúva aj `error` a `unhandledrejection`, a to isté sa zapíše na
 * server. S mapami zdrojov (zapnuté vo `vite.config.js`) sa zo zmenšeného
 * riadku dá dostať späť k nášmu kódu.
 *
 * ── Prečo je toho tak málo ────────────────────────────────────────────────
 * Najviac päť hlásení za jedno otvorenie systému a to isté len raz. Chyba
 * v slučke by inak zaplnila denník tisíckami rovnakých riadkov a tie
 * podstatné by sa v nich stratili.
 */
import { api } from './api';

const HRANICA = 5;
const PRESKOCIT = /ResizeObserver|Script error|Load failed|NetworkError|Failed to fetch/i;

let poslane = 0;
const uz = new Set();

function posli({ sprava, stack, adresa }) {
  const kluc = `${sprava}|${String(stack || '').slice(0, 200)}`;
  if (poslane >= HRANICA || uz.has(kluc)) return;
  if (PRESKOCIT.test(sprava)) return;
  uz.add(kluc);
  poslane += 1;

  const skript = [...document.querySelectorAll('script[src]')]
    .map((x) => x.src).find((x) => /assets\/index-/.test(x)) || '';

  try {
    api.post('/api/stats/chyba-rozhrania', {
      sprava: String(sprava).slice(0, 500),
      stack: String(stack || '').slice(0, 4000),
      adresa,
      balik: skript.split('/').pop(),
      druh: 'mimo vykreslenia',
    }).catch(() => {});
  } catch { /* hlásenie chyby nesmie spôsobiť ďalšiu chybu */ }
}

export function sledujChyby() {
  window.addEventListener('error', (e) => {
    /* Chýbajúci obrázok tiež vyvolá `error`, ale nemá `error` objekt –
     * to nie je pád rozhrania a do denníka nepatrí. */
    if (!e?.error && !e?.message) return;
    posli({
      sprava: e.error?.message || e.message,
      stack: e.error?.stack || `${e.filename || ''}:${e.lineno || 0}:${e.colno || 0}`,
      adresa: window.location.pathname + window.location.search,
    });
  });

  window.addEventListener('unhandledrejection', (e) => {
    const d = e?.reason;
    posli({
      sprava: d?.message || String(d || 'nesplnený prísľub'),
      stack: d?.stack || '',
      adresa: window.location.pathname + window.location.search,
    });
  });
}
